import { Component, Input } from '@angular/core';
import { PlanModel } from '../../../shared/models/plan.model';

@Component({
    selector: 'payment-resume-cart-recurrent',
    templateUrl: './payment.resume.cart-recurrent.component.html',
    styleUrls: ['../../payment.component.scss']
})
export class PaymentResumeCartRecurrentComponent {
    @Input('recurrentAs') recurrentAs: PlanModel;
}



// WEBPACK FOOTER //
// /codebuild/output/src2032928750/src/src/app/payment/resume/cart-recurrent/payment.resume.cart-recurrent.component.ts